import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import History from "@irati/utils/history"
import ViewPoll from "./ViewPoll"
import ViewVotes from "./ViewVotes"
import {Modal, ModalHeader} from "../shared/Modal"

export const VIEW_POLL = "VIEW_POLL"
export const VIEW_VOTES = "VIEW_VOTES"

const modals = [VIEW_POLL, VIEW_VOTES]

class PollsPopup extends Component {
  state = {
    show: modalStory(modals, VIEW_POLL)
  }

  static propTypes = {
    redirectToFeed: PropTypes.bool,
    poll: PropTypes.object.isRequired,
    onAfterExitModal: PropTypes.func
  }

  static defaultProps = {
    redirectToFeed: false,
    onAfterExitModal: null
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  show = (modalToShow = VIEW_POLL) =>
    this.setState({
      show: modalStory(modals, modalToShow)
    })

  handleHide = () =>
    this.setState({
      show: modalStory(modals, null)
    })

  handleAfterExit = () => {
    const {redirectToFeed, onAfterExitModal} = this.props
    if (!anyStoriesOpen(this.state.show)) {
      if (redirectToFeed) {
        History.push("/polls", this.context, false)
      }
      if (typeof onAfterExitModal === "function") {
        onAfterExitModal()
      }
    }
  }

  render() {
    const {show} = this.state
    const {poll} = this.props

    return (
      <Fragment>
        <Modal
          show={show[VIEW_POLL]}
          onHide={this.handleHide}
          onExited={this.handleAfterExit}
          useMobileStyling={false}
          renderHeader={({size}) => <ModalHeader users={poll.winners.results.map((w) => w.user)} size={size} trophy={poll.trophy} />}>
          <ViewPoll poll={poll} selectScreen={this.show} onDelete={this.handleHide} />
        </Modal>
        <Modal
          show={show[VIEW_VOTES]}
          onHide={this.handleHide}
          onExited={this.handleAfterExit}
          useMobileStyling={false}
          image={poll.trophy.href}
          onBack={() => this.show(VIEW_POLL)}>
          <ViewVotes poll={poll} />
        </Modal>
      </Fragment>
    )
  }
}

export default PollsPopup
